import { ProductItemFragment } from './Fragments/ProductItemFragment'

export const groupedProductDetailQuery = /* GraphQL */ `
    query groupedProductDetail($sku: String!) {
        products(filter: { sku: { eq: $sku } }) {
            items {
                __typename
                id
                sku
                name
                url_key
                stock_status
                small_image {
                    url
                }
                description {
                    html
                }
                short_description {
                    html
                }
                description {
                    html
                }
                image {
                    url
                    label
                }
                small_image {
                    url
                    label
                }
                thumbnail {
                    url
                    label
                }
                price_range {
                    __typename
                    minimum_price {
                        regular_price {
                            value
                            currency
                        }
                        final_price {
                            value
                            currency
                        }
                        discount {
                            amount_off
                        }
                    }
                }
                ... on GroupedProduct {
                    items {
                        position
                        qty
                        product {
                            id
                            sku
                            name
                            stock_status
                            image {
                                url
                                label
                            }
                            short_description {
                                html
                            }
                            price_range {
                                __typename
                                minimum_price {
                                    regular_price {
                                        value
                                        currency
                                    }
                                    final_price {
                                        value
                                        currency
                                    }
                                    discount {
                                        amount_off
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
